export default __webpack_public_path__ + "static/media/page-not-found.ab318eb6.svg";